<script setup lang="ts">
const props = defineProps<{
  id: number
}>()
</script>

<template>
  <span class="ml-2 inline-flex size-5 select-none items-center justify-center rounded-full bg-secondary-100 text-[0.625rem] font-bold text-secondary-700 group-hover:bg-secondary-300 group-hover:text-secondary-600 lg:size-7 lg:text-xs dark:bg-secondary-950 dark:text-secondary-700 dark:group-hover:bg-secondary-800">
    {{ props.id }}
  </span>
</template>
